
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { LoginForm } from "@/components/auth/LoginForm";
import { SignupForm } from "@/components/auth/SignupForm";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true); // Changed to true to make login the default view
  const { loading, handleLogin, handleSignup } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        navigate("/");
      }
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        // Store that user has signed up
        localStorage.setItem("hasSignedUp", "true");
        navigate("/");
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  const handleSignupSuccess = async (
    email: string,
    password: string,
    fullName: string,
    whatsapp: string,
    gender: string,
    birthday: Date | undefined
  ) => {
    await handleSignup(email, password, fullName, whatsapp, gender, birthday);
    setIsLogin(true); // Switch to login view after signup
  };

  return (
    <div className="container mx-auto py-8 max-w-md">
      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
        <div className="space-x-2 mb-6">
          <Button
            variant={isLogin ? "default" : "ghost"}
            onClick={() => setIsLogin(true)}
          >
            Sign In
          </Button>
          <Button
            variant={!isLogin ? "default" : "ghost"}
            onClick={() => setIsLogin(false)}
          >
            Sign Up
          </Button>
        </div>

        {isLogin ? (
          <LoginForm loading={loading} onSubmit={handleLogin} />
        ) : (
          <SignupForm loading={loading} onSubmit={handleSignupSuccess} />
        )}
      </div>
    </div>
  );
};

export default Auth;
